<template>
  <div class="NotFound">
    <PageHero title="Page not found" lede="That page does not exist or has moved." />
    <section class="section">
      <div class="container">
        <router-link to="/" class="btn">Back to home</router-link>
      </div>
    </section>
  </div>
</template>

<script>
import PageHero from '@/components/PageHero'

export default {
    name: 'NotFound',
    title: 'Not found - Ten Factor Growth',
    components: { PageHero }
}
</script>
